//libs

//styling
import './ProjectDetails.scss';

//assets

function ProjectDetails() {
  return (
    <div>
      <p>
        ProjectDetails
      </p>
    </div>
  );
}

export default ProjectDetails;
